module.exports = __webpack_public_path__ + "img/packing.78d388ce.svg";